import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import React from "react";
import BOEntitiesList from "./BOEntitiesList";

const TrustAdditionalDetailsEntities = () => {
  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardHeader title="Entity Details" />
        <CardContent>
          <Typography variant="body1" gutterBottom>
            Please provide the details of each of the Entities that are
            Beneficial Owners of the Trust and the Individuals that represent
            them.
          </Typography>
          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            <BOEntitiesList />
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TrustAdditionalDetailsEntities;
